module.exports = __webpack_public_path__ + "static/media/sharing_gift.c833e26c.jpg";